export interface n9ConfigInterface {
  n9config: {
    HYDROGENAPISERVER_API_URL?: string;
    SIGN_IN_URL?: string;
    TOS_URL?: string;
    SUPPORT_URL?: string;
    FAQ_URL?: string;
    PRIVACY_POLICY_URL?: string;
    SALES_URL?: string;
    HUBSPOT_TRACKING_CODE: string;
    CONTACT_US_URL?: string;
    VERSION?: string;
    TRACES_SAMPLE_RATE?: number;
    SENTRY_ENABLED?: boolean;
    SENTRY_DSN?: string;
    PENDO_ENABLED?: boolean;
    ENV?: string;
    PENDO_API_KEY?: string;
    PUBLIC_PATH?: string;
    FEATURE_RESEND_ENABLED?: boolean;
  };
}

class ConfigService {
  private config?: n9ConfigInterface;

  get environment(): string {
    return this.config?.n9config.ENV ?? "unknown-environment";
  }

  get version(): string {
    return this.config?.n9config.VERSION ?? "unknown-version";
  }

  get isSentryEnabled(): boolean {
    return !!this.config?.n9config.SENTRY_ENABLED;
  }

  get isPendoEnabled(): boolean {
    return !!this.config?.n9config.PENDO_ENABLED;
  }

  get tracesSampleRate(): boolean {
    return !!this.config?.n9config.TRACES_SAMPLE_RATE;
  }

  get pendoApiKey(): string {
    return this.config?.n9config.PENDO_API_KEY ?? "";
  }

  get sentryDsn(): string {
    return this.config?.n9config.SENTRY_DSN ?? "";
  }

  get signInUrl(): string {
    return this.config?.n9config.SIGN_IN_URL ?? "";
  }

  get supportUrl(): string {
    return this.config?.n9config.SUPPORT_URL ?? "";
  }

  get apiUrl(): string {
    return this.config?.n9config.HYDROGENAPISERVER_API_URL ?? "";
  }

  get faqUrl(): string {
    return this.config?.n9config.FAQ_URL ?? "";
  }

  get tosUrl(): string {
    return this.config?.n9config.TOS_URL ?? "";
  }

  get contactUsUrl(): string {
    return this.config?.n9config.CONTACT_US_URL ?? "";
  }

  get privacyPolicyUrl(): string {
    return this.config?.n9config.PRIVACY_POLICY_URL ?? "";
  }

  get publicPath(): string {
    return process.env.BASE_URL || "";
  }

  get featureResendEnabled(): boolean {
    return !!this.config?.n9config.FEATURE_RESEND_ENABLED;
  }

  get hubspotTrackingCode(): string {
    return this.config?.n9config.HUBSPOT_TRACKING_CODE ?? "";
  }

  init(jsonConfig: n9ConfigInterface) {
    this.config = jsonConfig;
  }
}

export const configService = new ConfigService();
